const toggleUserProfileNav = (toggle) => {
  document.body.classList.toggle('is-open-profile-nav');
  toggleBodyScrollLock(toggle);
};

// **********************************************************
// Open left nav mobile
// **********************************************************

attachEvent('.user-profile__back-button', 'click', (ev) => {
  toggleUserProfileNav(true);
  ev.preventDefault();
});

// **********************************************************
// Close left nav mobile
// **********************************************************

attachEvent('[data-close-profile]', 'click', (ev) => {
  toggleUserProfileNav(false);
  ev.preventDefault();
});

attachEvent('.user-profile__address-list .user-profile__address-buttons button', 'click', (ev) => {
  ev.preventDefault();
  if (ev.target.classList.contains('user-profile__address-delete-btn')) {
    window.location = `${localData.apiURL}?action=deleteUserShippingAddress&id=${ev.target.dataset.id}`;
  } else {
    window.location = `${localData.apiURL}?action=editLocation&id=${ev.target.dataset.id}`;
  }
});

document.addEventListener('DOMContentLoaded', () => {
  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape') {
      toggleUserProfileNav(false);
    }
  });

  if (document.querySelector('.user-profile')) {
    setTimeout(() => {
      const inputIds = ['#address_1'];
      inputIds.forEach((inputId) => {
        const input = document.querySelector(inputId);
        if (input) {
          const options = {};
          switch (localData.lang) {
            case 'sl':
              options.componentRestrictions = { country: 'si' };
              break;
            case 'hr':
              options.componentRestrictions = { country: 'hr' };
              break;
            default:
              options.componentRestrictions = {};
              break;
          }
          const autocomplete = new google.maps.places.Autocomplete(input, options);
          google.maps.event.addListener(autocomplete, 'place_changed', () => {
            const addressComponents = {
              postal_code: '',
              street_number: '',
              country: '',
              country_long: '',
              route: '',
              postal_town: '',
              locality: '',
            };
            const place = autocomplete.getPlace();
            place.address_components.forEach((component) => {
              const [type] = component.types;
              if (addressComponents[type] !== undefined) {
                addressComponents[type] = type === 'country' ? component.short_name : component.long_name;
                if (type === 'country') {
                  addressComponents.country_long = component.long_name;
                }
              }
            });
            if (addressComponents.street_number === '') {
              const inputValueParts = input.value.split(',');
              addressComponents.route = inputValueParts.length > 0 ? inputValueParts[0] : input.value;
            }
            const fields = {
              '#address_1': `${addressComponents.route ?? ''} ${addressComponents.street_number ?? ''}`.trim(),
              '#postcode': addressComponents.postal_code ?? '',
              '#city': addressComponents.postal_town ?? '',
              '#state': addressComponents.country_long ?? '',
            };
            for (const [selector, value] of Object.entries(fields)) {
              const el = document.querySelector(selector);
              if (el) el.value = value;
            }
          });
        }
      });
    }, 500);
  }
});
